
<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">

  
        <div class="card">
          <div class="card-header">
            <h4 class="card-tittle font-weight-bold"> Branches</h4>
          </div>
          <div class="row">
            <!-- First Column - Show -->
            <div class="col-md-6 col-12 d-flex align-items-center">
              <label class="d-flex align-items-center m-1 w-15">
                <div class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center">
                  Show :
                </div>
              </label>
              <label class="d-flex align-items-center m-1 w-50">
                <select class="form-control mx-25 w-50" [(ngModel)]="basicSelectedOption">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>

            <!-- Third Column - Search -->
            <div class="col-md-6 col-12 d-flex justify-content-end align-items-center">
              <label class="d-flex align-items-center m-1 w-100">
                <label class="d-flex align-items-center m-1 w-15">
                  <div class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center">
                    Search
                  </div>
                </label>

                <div class="input-group">
                  <input #searchInput type="text" class="form-control" (keyup)="filterUpdate($event)"
                    (search)="filterUpdate($event)"
                    placeholder="{{ 'MENU.DASHBOARD.SEARCH' | translate }}" />
                  <div class="input-group-append">
                    <button class="btn btnn" type="button">
                      <i class="fa fa-search"></i>
                      <!-- FontAwesome search icon -->
                    </button>
                  </div>
                </div>
              </label>
            </div>
          </div>
  
          <ngx-datatable
            [rows]="arrCountries"
            [rowHeight]="78" class="bootstrap core-bootstrap bg-white"
            [limit]="basicSelectedOption" [headerHeight]="60" [footerHeight]="38"
            [scrollbarH]="true" [columnMode]="'force'" 
          >
            <ngx-datatable-column name="Id" prop="id" [width]="80">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <small
                    class="font-small-3 font-weight-bold line-height-1 mb-25"
                  >
                    {{ row.id }}
                  </small>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
            <ngx-datatable-column
              name="Name "
              prop="custom_client_name"
              [flexGrow]="2"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p
                    class=" font-weight-bold line-height-1 mb-25 text-center"
                  >
                    {{ row.name }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
            <ngx-datatable-column
              name="Min Age"
              prop="custom_client_mobile"
             [flexGrow]="2"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
                    {{ row.minAge  }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
            <ngx-datatable-column
              name="Max Age"
              prop="custom_client_mobile"
             [flexGrow]="2"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
                    {{ row.maxAge   }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
  
  
            <!-- <ngx-datatable-column
              name="Created At"
              prop="custom_client_mobile"
             [flexGrow]="2"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
    {{ row.createdAt | date: 'yyyy-MM-dd'}}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
  
  
            <ngx-datatable-column
              name="Updated At"
              prop="custom_client_mobile"
             [flexGrow]="2"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
    {{ row.updatedAt| date: 'yyyy-MM-dd' }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
   -->

  
        
            <ngx-datatable-column name="{{ 'MENU.DASHBOARD.ACTIONS' | translate }}" [flexGrow]="10" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div ngbDropdown container="body">
                    <a
                      ngbDropdownToggle
                      href="javascript:void(0);"
                      class="hide-arrow"
                      id="dropdownBrowserState"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i
                        data-feather="more-vertical"
                        class="text-primary cursor-pointer mr-50"
                      ></i>
                    </a>
                    <div
                      ngbDropdownMenu
                      class="dropdown-menu-right"
                      aria-labelledby="dropdownBrowserState"
                    >
   <a [routerLink]="['/edit-branches', row.id]" ngbDropdownItem
                                    class="d-flex align-items-center"><i data-feather="edit-3" class="mr-50"></i>
                                    Edit</a>
                      <a
                        (click)="deleteBranches(row.id)"
                        ngbDropdownItem
                        class="d-flex align-items-center text-danger"
                        ><i data-feather="trash" class="mr-50"></i>Delete</a
                      >
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </section>
    </div>
  </div>
  